import {httpRequest} from '@/api/http-request'
import apiInterface from '@/api/interface'
import {getSystemMenuList} from '@/api/get-data'

export default {
  data() {
    return {
    }
  },
  created() {
    // 显示或隐藏Header
    if (this.$route.query.headerOpen) {
      this.$globalConfig.headerOpen = this.$route.query.headerOpen === '1' || this.$route.query.headerOpen === 'true'
    }
    // 设置全屏模式
    if (this.$route.query.fullScreen) {
      this.$globalConfig.fullScreen = this.$route.query.fullScreen === '1' || this.$route.query.fullScreen === 'true'
    }
  },
  mounted() {
  },
  methods: {
    // 单点登录
    ssoLogin(code, uiapType) {
      return new Promise((resolve, reject) => {
        if (this.$store.getters.userToken) { // 已登录
          resolve({
            'code': 200,
            'msg': 'ok'
          })
          return
        }

        if (code && uiapType) { // 单点登录
          let ssoLoginData = {
            code: code,
            uiapType: uiapType
          }
          httpRequest(apiInterface.ssoLogin, ssoLoginData).then(
            res => {
              if (res.code === 200) {
                if (res.data && res.data.accessToken) { // 缓存访问令牌
                  this.$store.commit('user/SET_TOKEN', res.data.accessToken)
                  console.log('succeed to sso login')
                }
                getSystemMenuList(() => { // 读取系统菜单列表
                  resolve(res)
                })
              }
            }).catch(err => {
            reject(err)
          })
        } else {
          resolve({
            'code': 400,
            'msg': 'bad request'
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sso-login-mixin.js